export const SELECT_POLICY_OWNER = 'SELECT_POLICY_OWNER'
export const selectPolicyOwner = (policyOwner) => ({
  type: SELECT_POLICY_OWNER,
  payload: policyOwner,
})

export const VALIDATE_SELECT_POLICY_OWNER = 'VALIDATE_SELECT_POLICY_OWNER'
export const validateSelectPolicyOwner = (policyOwner) => ({
  type: VALIDATE_SELECT_POLICY_OWNER,
  payload: policyOwner,
})

export const EDIT_MATURITY_ID_CARD = 'EDIT_MATURITY_ID_CARD'
export const editMaturityIDCard = (maturityIDCard) => ({
  type: EDIT_MATURITY_ID_CARD,
  payload: maturityIDCard,
})

export const MATURITY_VALIDATE = 'MATURITY_VALIDATE'
export const maturityValidate = (currentMaturityIDCard) => ({
  type: MATURITY_VALIDATE,
  payload: currentMaturityIDCard,
})

export const SET_VALID_MATURITY_ID_CARD = 'SET_VALID_MATURITY_ID_CARD'
export const setValidMaturityIDCard = (validIDCard) => ({
  type: SET_VALID_MATURITY_ID_CARD,
  payload: validIDCard,
})

export const SET_ERROR_VALIDATE_MATURITY_ID_CARD = 'SET_ERROR_VALIDATE_MATURITY_ID_CARD'
export const setErrorValidateMaturityIDCard = (errorMsg) => ({
  type: SET_ERROR_VALIDATE_MATURITY_ID_CARD,
  payload: errorMsg,
})

export const RESET_ERROR_VALIDATE_MATURITY_ID_CARD = 'RESET_ERROR_VALIDATE_MATURITY_ID_CARD'
export const resetErrorValidateMaturityIDCard = () => ({
  type: RESET_ERROR_VALIDATE_MATURITY_ID_CARD,
})

export const SET_ERROR_VALIDATE_MATURITY_STATUS = 'SET_ERROR_VALIDATE_MATURITY_STATUS'
export const setErrorValidateMaturityStatus = (errorMsg) => ({
  type: SET_ERROR_VALIDATE_MATURITY_STATUS,
  payload: errorMsg,
})

export const SET_ERROR_VALIDATE_SELECT_POLICY_OWNER = 'SET_ERROR_VALIDATE_SELECT_POLICY_OWNER'
export const setErrorValidateSelectPolicyOwner = (errorMsg) => ({
  type: SET_ERROR_VALIDATE_SELECT_POLICY_OWNER,
  payload: errorMsg,
})

export const RESET_ERROR_VALIDATE_SELECT_POLICY_OWNER = 'RESET_ERROR_VALIDATE_SELECT_POLICY_OWNER'
export const resetErrorValidateSelectPolicyOwner = () => ({
  type: RESET_ERROR_VALIDATE_SELECT_POLICY_OWNER,
})

export const UPDATE_MATURITY_VALIDATE = 'UPDATE_MATURITY_VALIDATE'
export const updateMaturityValidate = (maturityValidate) => ({
  type: UPDATE_MATURITY_VALIDATE,
  payload: maturityValidate,
})

export const RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE = 'RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE'
export const resetQuoteFormAfterMaturityValidate = () => ({
  type: RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE,
})

export const UPDATE_SUM_ASSURED_AFTER_MATURITY_VALIDATE = 'UPDATE_SUM_ASSURED_AFTER_MATURITY_VALIDATE'
export const updateSumAssuredAfterMaturityValidate = (sumAssured) => ({
  type: UPDATE_SUM_ASSURED_AFTER_MATURITY_VALIDATE,
  payload: sumAssured,
})

export const SELECT_PRODUCT_LIFE_READY_SIO = 'SELECT_PRODUCT_LIFE_READY_SIO'
export const selectProductLifeReadySIO = (productCode) => ({
  type: SELECT_PRODUCT_LIFE_READY_SIO,
  payload: productCode,
})

export const SELECT_PRODUCT_ISHIELD_SIO = 'SELECT_PRODUCT_ISHIELD_SIO'
export const selectProductIShieldSIO = (productCode) => ({
  type: SELECT_PRODUCT_ISHIELD_SIO,
  payload: productCode,
})

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})
